import { useCallback, useRef } from "react";

import { useRouter } from "@medbillai/navigation/router";
import { loginUrl } from "@medbillai/utils/urls";

import { useCoveragePlanStore } from "../screens/coverage/coveragePlanStore";
import { clearSeenMovements } from "../screens/coverage/movement/useMovementNotice";
import { clearCheckingWait } from "../screens/coverage/read/useCoverage";
import type { LogoutReason } from "./analytics";
import { analyticsService } from "./analytics";
import { useCaseStore } from "./caseStore";

export const useLogout = () => {
  const { push, replace } = useRouter();
  const url = loginUrl({ forceLogout: true });
  const hasLoggedOut = useRef(false);
  const clearAllPreviewData = useCaseStore(state => state.clearAllPreviewData);

  const logout = useCallback(
    ({
      reason,
      useReplace = false,
    }: {
      reason: LogoutReason;
      useReplace?: boolean;
    }) => {
      if (hasLoggedOut.current) {
        return;
      }

      hasLoggedOut.current = true;

      // Clear all preview case data from store to prevent local storage from
      // getting super bloated with preview case data.
      clearAllPreviewData();
      useCoveragePlanStore.setState({
        membershipId: undefined,
        tier: undefined,
      });
      clearSeenMovements();
      clearCheckingWait();

      analyticsService.trackEvent("Logout", {
        reason,
      });
      if (useReplace) {
        replace(url);
      } else {
        push(url);
      }
    },
    [push, replace, url, clearAllPreviewData],
  );

  return logout;
};
